import {
  DialInCountriesArrayItemCountryFor,
} from '@evercall/domain/vo/call/DialInCountriesArrayItem';
import {
  IDialInCountryForOption,
  IDialInCountryForOptions,
} from './interfaces';

export const DIAL_IN_COUNTRY_FOR_OPTIONS: IDialInCountryForOptions = {
  SPEAKERS_AND_PARTICIPANTS: {
    label: 'Speakers & Participants',
    value: DialInCountriesArrayItemCountryFor.SpeakersAndParticipants,
  },
  SPEAKERS_ONLY: {
    label: 'Speakers Only',
    value: DialInCountriesArrayItemCountryFor.SpeakersOnly,
  },
  PARTICIPANTS_ONLY: {
    label: 'Participants Only',
    value: DialInCountriesArrayItemCountryFor.ParticipantsOnly,
  },
};

export const DIAL_IN_COUNTRY_FOR_OPTIONS_ARRAY: Array<IDialInCountryForOption> = Object.values(
  DIAL_IN_COUNTRY_FOR_OPTIONS,
);
